import { ChangeDetectorRef, Component, effect, inject, input } from '@angular/core';

@Component({
  selector: 'pp-user-profile-picture',
  templateUrl: './user-profile-picture.component.html',
})
export class UserProfilePictureComponent {

  readonly alt = input<string>();
  readonly id = input<string>();
  readonly profilePictureUri = input<string>();
  readonly size = input<number>();

  // Identity handlers
  cacheBuster?: number;

  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      this.profilePictureUri();
      this.cacheBuster = new Date().getTime();
      this.cdr.markForCheck();
    });
  }
}
